module.exports = __webpack_public_path__ + "img/taili11.60ca917d.jpg";